import { HttpError } from '@magiczne/http-client'
import { defineStore } from 'pinia'
import { set } from 'vue'

import NotFoundError from '@/common/errors/not-found-error'
import { PaginatedResponse } from '@/common/models/data/common/pagination/paginated-response'
import { Post } from '@/common/models/data/dashboard/posts/post'
import { PostShowResponse } from '@/common/models/responses/post-show-response'
import { SignedRouteParams } from '@/common/models/signed-route-params'
import NewsRepository from '@/app/repositories/news-repository'

const useNewsStore = defineStore('news', {
    state: () => ({
        entries: new PaginatedResponse<Post>(),
        sluggedEntries: {} as Record<string, PostShowResponse>
    }),
    actions: {
        async loadPage (page = 1): Promise<void> {
            this.entries = await NewsRepository.index(page)
        },
        async loadBySlug (payload: { slug: string, params?: SignedRouteParams }): Promise<void> {
            try {
                this.setBySlug(await NewsRepository.bySlug(payload.slug, payload.params))
            } catch (e) {
                if (e instanceof HttpError && e.response?.status === 404) {
                    throw new NotFoundError()
                }
            }
        },
        setBySlug (payload: PostShowResponse): void {
            set(this.sluggedEntries, payload.post.slug, payload)
        }
    },
    getters: {
        bySlug: (state) => {
            return (slug: string): PostShowResponse => {
                if (!state.sluggedEntries[slug]) {
                    return new PostShowResponse()
                }

                return state.sluggedEntries[slug]
            }
        }
    }
})

export {
    useNewsStore
}
